<template>
    <div class="wizard__wrap wizard__wrap--invoices">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">{{ agencyName }}</div>
            </div>
            <div class="wizard__block-title">
                Invoices and payments
                <span class="subtitle">Please record your payment information</span>
            </div>
            <div class="wizard__block-table wizard__block-table--not-overflow">
                <div class="wizard__block-table-wrap table-wrap">
                    <table class="table">
                        <thead>
                            <tr>
                                <th style="min-width: 110px">Period</th>
                                <th>Due&nbsp;amount</th>
                                <th>Due&nbsp;date</th>
                                <th>Paid&nbsp;date</th>
                                <th>Paid&nbsp;amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(invoice, __index) in invoices">
                                <td>{{ getPeriodDate(invoice.period) }}</td>
                                <td>${{ numberWithCommas(invoice.amount) }}</td>
                                <td>{{ invoice.due_date }}</td>
                                <td>
                                    <div class="form-field form-field--datepicker" ref="datepicker">
                                        <input type="text" id="payment_received" :value="invoice.payment_received"
                                            name="payment_received" @changeDate="(e) =>
                                                onChangeDatePicker(
                                                    e.target.value,
                                                    invoice.id,
                                                    __index
                                                )
                                                " />
                                        <button type="button" style="
                                                margin: 0 8px;
                                                font-size: 16px;
                                            " class="btn btn--icon">
                                            <i class="icon icon-calendar"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-field form-field--text">
                                        <CurrencyInput :value="Number(invoice.collected)"
                                            :options="currency_input_setting" :change="(value, _key) =>
                                                updateInput(
                                                    value,
                                                    __index,
                                                    _key
                                                )
                                                " :key_input="'collected'" :index="__index" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div v-if="pending_invoices.length > 0">
                <div class="wizard__block-title">
                    <span class="subtitle">Pending invoices</span>
                </div>
                <div class="wizard__block-table wizard__block-table--not-overflow">
                    <div class="wizard__block-table-wrap table-wrap">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="min-width: 110px">Period</th>
                                    <th>Due&nbsp;amount</th>
                                    <th>Paid&nbsp;amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, __index) in pending_invoices">
                                    <td>{{ getPeriodDate(item.period) }}</td>
                                    <td>${{ numberWithCommas(item.amount) }}</td>
                                    <td>${{ numberWithCommas(item.collected) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="wizard__block-title">
                <span class="subtitle">Payments history</span>
            </div>
            <div class="wizard__block-table" style="max-width: 75%; margin: 0 auto 40px">
                <div class="wizard__block-table-wrap table-wrap">
                    <table class="table">
                        <thead>
                            <tr>
                                <th style="min-width: 110px">Period</th>
                                <th>Due&nbsp;amount</th>
                                <th>Due&nbsp;date</th>
                                <th>Paid&nbsp;date</th>
                                <th>Completed</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="invoice in paid_invoices">
                                <td>{{ getPeriodDate(invoice.period) }}</td>
                                <td>${{ numberWithCommas(invoice.amount) }}</td>
                                <td>{{ invoice.due_date }}</td>
                                <td>
                                    {{ invoice.payment_received }}
                                </td>
                                <td style="text-align: center; font-size: 18px">
                                    <i class="icon icon-checkmark"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button @click="onPrevPage" class="btn btn--prev btn--white">
                    Back
                </button>
                <button @click="onNextPage" class="btn btn--prev btn--white">
                    Next
                </button>
            </div>
            <!-- <div class="loader" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div> -->
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Datepicker } from "vanillajs-datepicker";
import CurrencyInput from "../components/CurrencyInput";
import { SECTIONS } from "../consts";
import ClipLoader from "vue-spinner/src/ClipLoader";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Invoices",
    components: {
        CurrencyInput,
        ClipLoader,
    },
    props: ["onChangeSection"],

    mounted() {
        this.getData();

        scrollToTop();
    },
    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        isHaveSalePages() {
            return this.$store.getters.getAllSalesPages ? true : false
        }
    },
    data() {
        return {
            SECTIONS,
            invoices: [],
            pending_invoices: [],
            paid_invoices: [],
            currency_input_setting: {
                currency: "USD",
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
            },
            datepicker_options: {
                format: "mm/dd/yyyy",
                pickLevel: 0,
                autohide: true,
            },
            statuses: [
                {
                    id: 1,
                    name: "Unpaid",
                },
            ],
            filter: {
                status: [],
            },
            validation_rules: {},
            isInitPage: false,
            isLoading: false,
        };
    },

    methods: {
        getPeriodDate(date) {
            return date ? moment(date).format("MM/YYYY") : "";
        },
        async getData() {
            this.isLoading = true;

            await axios
                .post("/api/wizard/getList", {
                    page: "invoices_and_payments",
                })
                .then((res) => {
                    if (
                        typeof res.data.page !== "object" ||
                        res.data.page.length <= 0
                    ) {
                        this.onChangeSection(
                            SECTIONS.FINAL_DASHBOARD,
                            SECTIONS.EDIT_SALE_LINE_ITEM
                        );
                    } else {
                        this.invoices = res.data.page.invoices || [];
                        this.pending_invoices = res.data.page.pending_invoices || [];
                        this.paid_invoices = res.data.page.history;
                    }
                })
                .catch((err) =>
                    console.log("err getData invoices and payments", err)
                )
                .finally(() => {
                    this.initValidation();
                    this.initDatePicker();
                });
        },
        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker) {
                return;
            }

            const initDP = (__node) => {
                let datepicker = null;
                const input = __node.querySelector("input");
                const button = __node.querySelector("button");

                if (input) {
                    datepicker = new Datepicker(input, {
                        ...this.datepicker_options,
                    });
                }

                if (button) {
                    button.addEventListener("click", () => {
                        if (!datepicker.active) {
                            datepicker.show();
                        }
                    });
                }
            };

            if (Array.isArray(node__datepicker)) {
                node__datepicker.forEach((_datepicker) => initDP(_datepicker));
            } else {
                initDP(node__datepicker);
            }
        },

        onChangeDatePicker(value, invoice_id, index) {
            const date = value;

            if (date) {
                const invoice_index = this.invoices.findIndex(
                    (i) => i.id === invoice_id
                );

                if (invoice_index != -1) {
                    this.invoices[invoice_index].payment_received = date;
                }

                this.updateInput(date, index, "payment_received");
            }
        },
        onChangeStatusCheckbox(e) {
            if (e.target.checked) {
                this.filter.status.push(e.target.value);
            } else {
                this.filter.status = this.filters.status.filter(
                    (i) => i != e.target.value
                );
            }
        },
        onChangeStatusAll(e) {
            if (e.target.checked) {
                this.filter.status = [];
                this.statuses.forEach((filter) => {
                    const _checkbox =
                        this.$refs[`filter_status_${filter.id}`][0];
                    if (_checkbox.checked) {
                        _checkbox.checked = false;
                        _checkbox.dataset.checked = false;
                    }
                });
            }
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        initValidation() {
            let __object_rules = {};

            let dataArray = Object.keys(this.invoices).map((key, index) => ({
                ...this.invoices[key],
            }));

            if (
                typeof this.invoices === "object" &&
                !Array.isArray(this.invoices)
            ) {
                dataArray = Object.keys(this.invoices).map((key, index) => ({
                    ...this.invoices[key],
                }));
            } else {
                dataArray = this.invoices;
            }

            dataArray.forEach((invoice) => {
                return (__object_rules[invoice.id] = {
                    collected: {
                        required: true,
                        value: invoice.collected,
                    },
                    payment_received: {
                        required: true,
                        value: invoice.payment_received,
                    },
                });
            });

            this.validation_rules = __object_rules;

            setTimeout(() => {
                this.isInitPage = true;
            }, 1000);

            this.isLoading = false;
        },
        checkValidation() {
            if (true) {
                let isValidate = true;

                let dataArray = Object.keys(this.invoices).map(
                    (key, index) => ({
                        ...this.invoices[key],
                    })
                );

                if (
                    typeof this.invoices === "object" &&
                    !Array.isArray(this.sales)
                ) {
                    dataArray = Object.keys(this.invoices).map(
                        (key, index) => ({
                            ...this.invoices[key],
                        })
                    );
                } else {
                    dataArray = this.invoices;
                }

                dataArray.forEach((invoice) => {
                    const _id = invoice.id;
                    const invoice_rules = this.validation_rules[_id];

                    if (
                        invoice_rules.collected.required &&
                        !invoice_rules.collected.value
                    ) {
                        isValidate = false;
                    } else if (
                        invoice_rules.payment_received.required &&
                        !invoice_rules.payment_received.value
                    ) {
                        isValidate = false;
                    }
                });

                return isValidate;
            }
        },
        updateValidationField(invoice_id, key, value) {
            this.validation_rules[invoice_id][key].value = value;
        },
        updateDataByField(key, value, id = 1) {
            axios
                .post("api/wizard/updateDraft", {
                    action: "updateMasterInvoice",
                    data: {
                        key,
                        value,
                        id,
                    },
                })
                .then((res) => {
                    //this.$toast.success(res.data.message);

                    this.updateValidationField(id, key, value);
                })
                .catch((err) => console.log("Err updateDataByField", err));
        },

        updateInput: _.debounce(function (value, index, key) {
            if (this.isInitPage) {
                this.updateDataByField(key, value, this.invoices[index].id);
            }
        }, 500),

        onNextPage() {
            let isValidate = this.checkValidation();

            if (isValidate) {
                this.onChangeSection(SECTIONS.FINAL_DASHBOARD);
            } else {
                this.$toast.error(
                    "You should fill in the amounts and dates for each row of the table"
                );
            }
        },
        onPrevPage() {
            if (this.isHaveSalePages) {
                this.onChangeSection(
                    SECTIONS.EDIT_SALE_LINE_ITEM,
                    SECTIONS.EDIT_SALE_LINE_ITEM
                )
            } else {
                this.onChangeSection(
                    SECTIONS.DASHBOARD,
                    SECTIONS.INVOICES
                )
            }
        }
    },
};
</script>
